export default "__VITE_ASSET__BxSHsMj2__"